import { WindowFrame } from '../../../components/window';
import type { WindowPanelProps } from '../../../types/window';
import { TERRAIN_OPTIONS, type TerrainId } from '../../../game/catalog';
import { CatalogCard } from '../shared/CatalogCard';
import '../shared/sandboxPickers.css';

export interface TerrainPickerProps extends WindowPanelProps {
  selectedId: TerrainId;
  onSelect: (id: TerrainId) => void;
}

const TerrainPicker = (props: TerrainPickerProps) => {
  return (
    <WindowFrame
      title="TERRAIN"
      windowId="terrain"
      zIndex={props.data}
      theme="dark"
      sizePreset="md"
      onClose={() => props.parentCallback(false, 'showHideTerrain')}
      onFocus={() => props.parentCallbackTwo(0, 0, 0, 0, 0, 1, 0)}
      contentClassName="sandbox-picker-window-content"
    >
      <div className="sandbox-picker-body">
        <p className="sandbox-picker-intro">SANDBOX ENVIRONMENT — APPLIES IMMEDIATELY</p>
        <div className="sandbox-picker-grid">
          {TERRAIN_OPTIONS.map((item) => (
            <CatalogCard
              key={item.id}
              item={item}
              selected={props.selectedId === item.id}
              onSelect={() => props.onSelect(item.id)}
            />
          ))}
        </div>
      </div>
    </WindowFrame>
  );
};

export default TerrainPicker;
